module.exports = __webpack_public_path__ + "static/media/HKGrotesk-SemiBold.7cda97db.woff2";